import React, { useState } from "react";
import { PaymentElement } from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import {Button} from "@material-ui/core";
import useStyles from "../../assets/styles/ProgramRatingStyles";
import Box from "@material-ui/core/Box";
import {RATING_TYPE} from "../../utils/constants";

export default function CheckoutForm(props) {
    const classes = useStyles();
    const {application_id, rating_type, handleSaveBillingInfo, isCreatorProgram} = props;
    const rating = rating_type === RATING_TYPE.CPC_STARS_RATING ? 'dq_stars_rating' : 'dq_rating';

    const stripe = useStripe();
    const elements = useElements();

    const [message, setMessage] = useState(null);
    const [isProcessing, setIsProcessing] = useState(false);

    const handleSubmit = async () => {

        if (!stripe || !elements) {
            // Stripe.js has not yet loaded.
            // Make sure to disable form submission until Stripe.js has loaded.
            return;
        }

        setMessage(null);
        setIsProcessing(true);
        await handleSaveBillingInfo();
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                // Make sure to change this to your payment completion page
                return_url: isCreatorProgram ? `${window.location.origin}/program/${application_id}/upgrade` : `${window.location.origin}/${rating}/${application_id}/payment`,
            },
        });

        if (error.type === "card_error" || error.type === "validation_error") {
            setMessage(error.message);
        } else {
            setMessage("An unexpected error occurred.");
        }

        setIsProcessing(false);
    };

    return (
        <>
            <PaymentElement id="payment-element" />
            <br/>
            <Box align={'center'}>
                <Button id="submit" className={classes.badgeButton} style={{borderRadius:'15px', fontSize:'13px', padding:'12px 24px'}} variant={'contained'} color={'primary'} disabled={isProcessing || !stripe || !elements} onClick={() => handleSubmit()}>
                    {isProcessing ? "Processing..." : "Pay now"}
                </Button>
            </Box>
            <br/>
            {/* Show any error or success messages */}
            {message && <div style={{color: "red"}}>{message}</div>}
        </>
    );
}